import React from "react";
import { useTasksRetrieval } from "@planzone/view-models";

import { Loader } from "../loader";
import { ScrollPane } from "../scrollPane";
import { Section } from "../section";
import { filterSearch } from "../utils";
import { Task } from "./task";
import { Props } from "./types";
import styles from "./styles.scss";

function Tasks({
  project,
  resource,
  search,
  selected,
  onSelect,
  isOpen,
}: Props) {
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    tasks,
    retrieveTasks,
  } = useTasksRetrieval(project, resource);

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveTasks({ project, resource });
  }, [project.uuid, resource.uuid]);

  return (
    <Section
      header={<div className={styles.header} />}
      list={
        <ScrollPane>
          <div className={styles.list}>
            {!isRequestPending ? (
              <ul className={styles.tasks}>
                {filterSearch(tasks, search)
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((task) => (
                    <li key={task.uuid}>
                      <Task
                        task={task}
                        isSelected={selected?.uuid === task.uuid}
                        onSelect={() => onSelect(task)}
                      />
                    </li>
                  ))}
              </ul>
            ) : (
              <div className={styles.loader}>
                <Loader />
              </div>
            )}
          </div>
        </ScrollPane>
      }
      isHeaderToggleDisabled
      isOpen={isOpen}
    />
  );
}

export { Tasks };
